"use strict";

angular.module('app.shared.inactiveSubscriptionOverlay.inactiveSubscriptionOverlayDirective', [])
    .directive('inactiveSubscriptionOverlay', [
        function () {
            return {
                restrict: 'E',
                templateUrl: 'components/shared/inactiveSubscriptionOverlay/inactiveSubscriptionOverlayView.html'
            }
        }
    ]);


// WEBPACK FOOTER //
// ./app.v2/components/shared/inactiveSubscriptionOverlay/inactiveSubscriptionOverlayDirective.js